import React from "react";

// this component exist only due to limitations in react router V3
const CreditContainer = ({ children }) =>
  <div>
    {children}
  </div>;

export default CreditContainer;



// WEBPACK FOOTER //
// ./src/components/common/credit/CreditContainer.js